import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, withCtx as _withCtx, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ElAside, ElContainer, ElFooter, ElSlider } from 'element-plus'
import MenuView from './MenuView.vue'
import HeaderView from './HeaderView.vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'MainView',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  const _component_ElHeader = _resolveComponent("ElHeader")!
  const _component_RouterView = _resolveComponent("RouterView")!
  const _component_ElMain = _resolveComponent("ElMain")!

  return (_openBlock(), _createBlock(_unref(ElContainer), null, {
    default: _withCtx(() => [
      _createVNode(_unref(ElAside), null, {
        default: _withCtx(() => [
          _createVNode(MenuView)
        ]),
        _: 1
      }),
      _createVNode(_unref(ElContainer), null, {
        default: _withCtx(() => [
          _createVNode(_component_ElHeader, null, {
            default: _withCtx(() => [
              _createVNode(HeaderView)
            ]),
            _: 1
          }),
          _createVNode(_component_ElMain, { style: {"display":"flex","padding":"20px 0px","flex":"1","flex-direction":"column","align-items":"center"} }, {
            default: _withCtx(() => [
              _createVNode(_component_RouterView, { id: "main" })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})